import './MarkedTitle.scss'

import React, {ReactElement} from 'react'
import {style} from '../../util/style'
import {Theme} from '../Theme'

const styles = style('markedtitle')

export type MarkedTitleType = {
	className?: string
	title: string
	direction?: 'left' | 'right'
	tag?: React.FC<any>
	as?: 'h2' | 'h3' | 'h4'
}

export const MarkedTitle: React.FC<MarkedTitleType> = ({
	className,
	title,
	direction,
	tag,
	as = 'h3'
}) => {
	if (!title) return null
	const Tag = tag || Theme.H3

	return (
		<Tag
			className={styles().with(className).mod(direction)}
			mod={['white', 'marked', 'slantleft']}
			as={as}
		>
			{title}
		</Tag>
	)
}
